import React from 'react';
import EmptyProjectWrapper from './Components/EmptyProjectWrapper';
import Router from './Components/Router';
import StyledBox from './styles';

interface MainWindowProps {
  setRef: React.Dispatch<React.SetStateAction<HTMLDivElement | null | undefined>>;
}

export default function MainWindow(props: MainWindowProps) {
  const { setRef } = props;

  return (
    <StyledBox ref={(r: HTMLDivElement) => { setRef(r); }} id="main-window">
      <EmptyProjectWrapper>
        <Router />
      </EmptyProjectWrapper>
    </StyledBox>
  );
}
